import { useConnection } from "@solana/wallet-adapter-react";
import { RatioPositionFetcher } from "@stepfinance/lending";
import { useEffect, useMemo } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useRefreshContext } from "../../contexts/refresh";
import type { IsolatedVaultLendingData } from "../../types/lending";
import { useRatioQuery } from "../queries/lending/useRatioQuery";
import { useLendingVaultsQuery } from "../queries/useLendingVaultsQuery";

export const useRatio = (): IsolatedVaultLendingData["ratio"] => {
  const { publicKey } = useEnrichedWallet();
  const { connection } = useConnection();
  const { refreshID } = useRefreshContext();
  const { data: lendingVaultsData } = useLendingVaultsQuery();

  const fetcher = useMemo(() => {
    if (!publicKey || !lendingVaultsData) {
      return undefined;
    }
    return new RatioPositionFetcher(publicKey, connection, lendingVaultsData.ratioVaults);
  }, [connection, publicKey, lendingVaultsData]);

  const { data: positions, refetch } = useRatioQuery(fetcher);

  useEffect(() => {
    refetch().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshID]);

  return {
    collateral: {},
    isolatedVaults: positions ?? {},
    yieldFarms: {},
  };
};
